import {classNames} from 'utils';

interface IARButtonModelSelect {
  img: string;
  label: string;
  onClick: () => void;
  selected?: boolean;
}

const ARButtonModelSelect = ({img, label, onClick, selected = false}: IARButtonModelSelect) => {
  return (
    <div className="col-span-1 flex flex-col items-center gap-2 flex-shrink-0 w-40">
      <img
        src={img}
        alt={label}
        className={classNames('aspect-square bg-slate-200 object-cover rounded-md border-2', selected ? 'border-[#34bb78]' : 'border-transparent')}
        onClick={onClick}
      />
      <p className="text-center text-slate-600 line-clamp-1 capitalize">{label.split('_').join(' ')}</p>
    </div>
  );
};

export default ARButtonModelSelect;
